'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechprofilees', {
        url: '/speechprofilees',
        template: '<speechprofilees></speechprofilees>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechprofilees/speechprofilees.routes.js